import { useAuth } from '../context/AuthContext';

// Helper function to get the API key from localStorage
function getApiKey() {
  return localStorage.getItem('apiKey');
}

function getToken() {
    return localStorage.getItem('token');
}

export async function loginToApi(email, password) {
    const response = await fetch(`/api/license/login?email=${email}&password=${password}`, {
        method: 'GET'
    });

    if (!response.ok) {
        throw new Error('Failed to login');
    }

    const apiKey = await response.json();
    return apiKey;
}

export async function swapDealerToken(id) {
    const response = await fetch('/api/license/dealerToken/' + id, {
        method: 'GET'
    });

    if (!response.ok) {
        throw new Error('Failed to login');
    }

    const key = await response.text();
    const isMaster = response.headers.get("IsMaster");
    //console.log("apiKey: " + key);
    //console.log("isMaster: " + isMaster);
    return { key, isMaster };
}

// Fetch licenses
export async function fetchLicenses() {
    const apiKey = getApiKey();
    const token = getToken();
  const response = await fetch('/api/license', {
    headers: {
          "apikey": apiKey,
          "token": token
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch licenses');
  }

  return response.json();
}

// Add a license
export async function createLicense(license, dealerPassword) {
  const apiKey = getApiKey();
  const response = await fetch('/api/license', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
        'apikey': apiKey,
        'distributor': dealerPassword
    },
    body: JSON.stringify(license)
  });

  if (!response.ok) {
    throw new Error('Failed to add license');
  }
  return response.json();
}

// Delete a license
export async function deleteLicense(licenseId, dealerPassword) {
  const apiKey = getApiKey();
  const response = await fetch(`/api/license/${licenseId}`, {
    method: 'DELETE',
    headers: {
        'apikey': apiKey,
        'distributor': dealerPassword
    }
  });

  if (!response.ok) {
    throw new Error('Failed to delete license');
  }
  return response.json();
}

// Edit a license
export async function updateLicense(license, token) {
  const apiKey = getApiKey();
    const response = await fetch('/api/license', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'apikey': apiKey,
            'token': token
    },
    body: JSON.stringify(license)
  });

  if (!response.ok) {
    throw new Error('Failed to edit license');
  }
  return response.json();
}

export async function updateOwnerDetails(id, details, restaurantId) {
    const response = await fetch('/api/license/owner/' + id + '?restaurantId=' + restaurantId, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(details)
    });

    if (!response.ok) {
        throw new Error('Failed to save owner details');
    }
}

// Toggle activation status of a license
export async function toggleActivation(license) {
  const apiKey = getApiKey();
    const action = license.isActive ? 'deactivate' : 'activate';
    if (license.isActive) {
        const response = await fetch(`/api/license/${action}/${license.id}`, {
            method: 'GET',
            headers: {
                'apikey': apiKey
            }
        });

        if (!response.ok) {
            throw new Error('Failed to toggle activation status');
        }

        return response.json();
    } else {
        const response = await fetch(`/api/license/${action}/${license.id}?tillId=${license.tillId}&hardwareKey=${license.hardwareKey}`, {
            method: 'GET',
            headers: {
                'apikey': apiKey
            }
        });

        if (!response.ok) {
            throw new Error('Failed to toggle activation status');
        }

        return response.json();
    }
}

export async function fetchDealers() {
    const apiKey = getApiKey();
    const response = await fetch(`/api/license/classic/distributors`, {
        method: 'GET',
        headers: {
            'apikey': apiKey
        }
    });

    if (!response.ok) {
        throw new Error('Failed to fetch dealers');
    }

    return response.json();
}

export async function createDealer(dealer) {
    const apiKey = getApiKey();
    const response = await fetch(`/api/license/classic/distributor`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'apikey': apiKey
        },
        body: JSON.stringify(dealer)
    });

    if (!response.ok) {
        throw new Error('Failed to update dealer');
    }

    return response.json();
}

export async function updateDealer(dealer) {
    const apiKey = getApiKey();
    const response = await fetch(`/api/license/classic/distributor`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'apikey': apiKey
        },
        body: JSON.stringify(dealer)
    });

    if (!response.ok) {
        throw new Error('Failed to update dealer');
    }

    return response.json();
}

export async function deleteDealer(id) {
    const apiKey = getApiKey();
    const response = await fetch(`/api/license/classic/distributors/${id}`, {
        method: 'DELETE',
        headers: {
            'apikey': apiKey
        }
    });

    if (!response.ok) {
        throw new Error('Failed to fetch dealers');
    }

    return response.json();
}